import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTemporaryStorage } from 'hooks/useTemporaryStorage';
import { subscribeToSubsite } from 'modules/main/store/ducks/subscribedSubsites.actions';
import {
  saveListing,
  saveSearch,
} from 'modules/main/store/ducks/userEnvironment.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { getFirstParam, getRelativeURL, isExternalURL } from 'utils/url';

export function useTemporaryStorageHandler() {
  const dispatch = useMainDispatch();
  const navigate = useNavigate();
  const [navigated, setNavigated] = useState(false);
  const tmpId =
    typeof window !== 'undefined'
      ? getFirstParam(window.location, 'tmpId')
      : '';

  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const [, temporaryStorage] = useTemporaryStorage(tmpId);

  useEffect(() => {
    if (temporaryStorage) {
      if (
        'redirectUrl' in temporaryStorage &&
        typeof temporaryStorage.redirectUrl === 'string'
      ) {
        setRedirectUrl(temporaryStorage.redirectUrl);
      }

      if ('savedListing' in temporaryStorage) {
        dispatch(
          saveListing(
            temporaryStorage.savedListing.id,
            temporaryStorage.savedListing.type,
          ),
        );
      }

      if ('subscribedSubsite' in temporaryStorage) {
        dispatch(
          subscribeToSubsite(
            temporaryStorage.subscribedSubsite.subscribedSubsiteId,
          ),
        );
      }

      if ('savedSearch' in temporaryStorage) {
        dispatch(saveSearch(temporaryStorage.savedSearch));
      }
    }
  }, [dispatch, temporaryStorage, tmpId]);

  if (redirectUrl && !navigated) {
    if (isExternalURL(redirectUrl)) {
      window.location.href = redirectUrl;
    } else {
      navigate(getRelativeURL(redirectUrl), { replace: true });
    }
    setNavigated(true);
  }

  return null;
}
